import { Pipe, PipeTransform } from '@angular/core';
import { MapPlace } from '../models/MapPlace';

@Pipe({
  name: 'placesBySector'
})
export class PlacesBySectorPipe implements PipeTransform {
  transform(places: MapPlace[] = [], sectorId: string): MapPlace[] {
    if (!sectorId) return places;
    return places.filter(p => {
      return !!p.tickets.find(t => t.sectorId == sectorId);
    });
  }
}
